import { Component, Input, OnInit } from '@angular/core';
import { IRouteJobScreenTasksTaskInfo } from '../../../../interfaces/screen-specific/job-screen/route-details/route-job-screen-tasks';

@Component({
  selector: 'route-job-screen-task-times',
  templateUrl: './route-job-screen-task-times.component.html',
  styleUrls: ['./route-job-screen-task-times.component.scss'],
})
export class RouteJobScreenTaskTimesComponent implements OnInit {
  @Input() routeRecommendationTask: IRouteJobScreenTasksTaskInfo;

  constructor() {}

  ngOnInit(): void {}
}
